import { useQuery } from '@tanstack/react-query';

import { SafetyEventClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const safetyEventClient = new SafetyEventClient(apiBaseUrl);

function useGetApprovalList() {
  return useQuery({
    queryKey: [queryKeys.SafetyEvent.ApprovalList],
    queryFn: () => safetyEventClient.getApprovalList(),
  });
}

export default useGetApprovalList;
